import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommunicationService {
    private http = inject(HttpClient);
    private apiUrl = '/api/communication';

    /**
     * Sends a test email to the specified address.
     * @param to Email address to send the test email to.
     */
    testEmail(to: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/test-email`, { params: { to }, responseType: 'text' });
    }

    /**
     * Triggers the daily report check manually.
     */
    triggerDailyCheck(): Observable<any> {
        return this.http.post(`${this.apiUrl}/trigger-daily-check`, {}, { responseType: 'text' });
    }

    /**
     * Notifies managers that a user has submitted a daily report.
     * @param data Report submission details (user, project, description, duration).
     */
    notifyReportSubmitted(data: { userId: string, userName: string, projectName: string, description: string, duration: string }): Observable<any> {
        return this.http.post(`${this.apiUrl}/notify/report-submitted`, data);
    }
}
